import WeatherMeteo from 'components/WeatherMeteo'
import React from 'react'

const WeatherMeteoPage = () => {
  return <WeatherMeteo />
}

export default WeatherMeteoPage
